import "styles/App.css";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Banner from "components/headers/Banner";
import HospitalHeader from "components/headers/HospitalHeader";
import HospitalFooter from "components/footers/HospitalFooter";
import MainNavBar from "components/navs/MainNavBar";
import Cookies from "universal-cookie";

import { useDispatch, useSelector } from "react-redux";
import { focusHospital, selectHospital } from "state/slices/hospitalSlice";

const cookies = new Cookies();

function HospitalHome() {
  const dispatch = useDispatch();
  const focusedHospital = useSelector(selectHospital);
  const hospitalId = focusedHospital.id;

  // Restore last focused centre from cookie after the header selector was removed.
  useEffect(() => {
    if (hospitalId && Number(hospitalId) > 0) return;
    const cookieHospitalId = Number(cookies.get("hospital"));
    if (cookieHospitalId > 0) {
      dispatch(focusHospital({ id: cookieHospitalId }));
    }
  }, [dispatch, hospitalId]);

  return (
    <>
    <Banner />
    <div className="d-flex justify-content-between flex-row no-wrap">
      <MainNavBar />
      <div className="flex-grow-1">
        <HospitalHeader />
        <div id="home-container">
          <Outlet context={[hospitalId]} />
        </div>
        <HospitalFooter />
      </div>
    </div>
    </>
  );
}

export default HospitalHome;
